import { createSlice } from '@reduxjs/toolkit';
import {
  getStoresReducers,
  getStoreReducers,
  createStoreReducers,
  updateStoreReducers,
  updateRefreshTokenReducers,
  getStoresListReducers,
  uploadDescriptionTemplateReducers,
  deleteStoreReducers,
  loadListingsReducers,
  storePoliciesReducers,
  loadListingsProgressReducers,
} from './stores.reducers';

const initialState = {
  store: null,

  stores: [],
  totalStores: 0,
  totalPages: 0,
  currentPage: 1,

  getStoresStatus: 'idle',
  getStoreStatus: 'idle',
  createStoreStatus: 'idle',
  updateStoreStatus: 'idle',
  updateRefreshTokenStatus: 'idle',
  uploadDescriptionTemplateStatus: 'idle',
  deleteStoreStatus: 'idle',
  loadListingsStatus: 'idle',

  storePolicies: null,
  getStorePoliciesStatus: 'idle',
  refreshStorePoliciesStatus: 'idle',
  updateDefaultPoliciesStatus: 'idle',
  policiesProcessStatus: null,
  isPoliciesRunning: false,
  policiesRefreshStatus: null,
  isPoliciesRefreshing: false,
  downloadPoliciesReportStatus: 'idle',

  loadListingsProcessStatus: null,
  isLoadListingsRunning: false,
  updateLoadListingsScheduleStatus: 'idle',
  downloadLoadListingsReportStatus: 'idle',

  getStoresListStatus: 'idle',
  list: [],

  error: null,
};

const storesSlice = createSlice({
  name: 'stores',
  initialState,
  reducers: {
    setPoliciesProcessStatusFromSocket(state, action) {
      state.policiesProcessStatus = action.payload;
      state.isPoliciesRunning = Boolean(action.payload?.isRunning);
    },
    setPoliciesRefreshStatusFromSocket(state, action) {
      state.policiesRefreshStatus = action.payload;
      state.isPoliciesRefreshing = Boolean(action.payload?.isRunning);
    },
    setLoadListingsProcessStatusFromSocket(state, action) {
      state.loadListingsProcessStatus = action.payload;
      state.isLoadListingsRunning = Boolean(action.payload?.isRunning);
    },
  },
  extraReducers: (builder) => {
    getStoresReducers(builder);
    getStoreReducers(builder);
    createStoreReducers(builder);
    updateStoreReducers(builder);
    updateRefreshTokenReducers(builder);
    getStoresListReducers(builder);
    uploadDescriptionTemplateReducers(builder);
    deleteStoreReducers(builder);
    loadListingsReducers(builder);
    storePoliciesReducers(builder);
    loadListingsProgressReducers(builder);
  },
});

export const {
  setPoliciesProcessStatusFromSocket,
  setPoliciesRefreshStatusFromSocket,
  setLoadListingsProcessStatusFromSocket,
} = storesSlice.actions;

export default storesSlice.reducer;
